import PropTypes from "prop-types";
import "../../dashboard-cme/dashboard-cme.scss";
import React, { useState, useEffect } from "react";
import ViolationIcon from "../../../../assets/icons/Icon-Complete-56px-Gold-50.svg";
import { CMEWorkload } from "../cme-util/cme-utils";
import ViewMembersPanelNew from "../../../../components/view-members-new/view-members-new";
import { getLastUpdatedDateColor, getLastUpdatedTootlTip } from "../../dashboard-util/dashboard-utils";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import DynamicFieldBulk from "../../../../components/DynamicFieldBulk/DynamicFieldBulk";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";

const CMEProjectModal = (props) => {
    const [projectsMembers, setProjectsMembers] = useState(props.item.MemberProjects ? props.item.MemberProjects : null);

    useEffect(() => {
        if (props.item.MemberProjects) setProjectsMembers(props.item.MemberProjects);
    }, [props]);

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            contentClassName="dashboard-modal-styles"
            dialogClassName="dashboard-modal"
            scrollable={true}
        >
            <Modal.Header
                className="dashboard-modal-header"
                closeButton
            >
                <Modal.Title className="dashboard-modal-title ml-4 ">
                    {props.item?.AnalystAssociate}
                    <p className="subDepartmentTitle">Member Time Log</p>
                </Modal.Title>
            </Modal.Header>
            <FluentProvider theme={webLightTheme}>
                <Modal.Body className="cmeModalBody">
                    <div>
                        {props.item.IsStaffer ?
                            <table className="CMEDashboard">
                                <thead className="MemberTableColumnHeader cmeHeader">
                                    <tr className="tableColumnTitles tableHeader">
                                        {
                                            projectsMembers[0]?.ProjectDynamicFields?.map((dynamicColumns, index) => {
                                                return (
                                                    index == 1
                                                        ?
                                                        <>
                                                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Project Name</th>
                                                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Members</th>
                                                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">   {dynamicColumns?.Label}</th>
                                                        </>
                                                        :
                                                        index == 6
                                                            ? <>
                                                                <th className="col-md-2 col-sm-2 textEllipsis headerSorted">Workload</th>
                                                                <th className="col-md-1 col-sm-1 textEllipsis headerSorted">M-F Hours</th>
                                                                <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Saturday Hours</th>
                                                                <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Sunday hours</th>
                                                                <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Total Hours</th>
                                                                <th className="col-md-1 col-sm-1 textEllipsis headerSorted">
                                                                    {dynamicColumns?.Label}
                                                                </th>
                                                            </>
                                                            :
                                                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">
                                                                {dynamicColumns?.Label}
                                                            </th>
                                                )
                                            })
                                        }
                                        {projectsMembers[0]?.ProjectDynamicFields?.length > 0 && getLastUpdatedTootlTip(<th className="col-md-1 col-sm-1 textEllipsis headerSorted">Last Updated</th>)}
                                    </tr>
                                </thead>
                                <tbody className="tableBody cmeBody">
                                    {projectsMembers.length > 0 &&
                                        projectsMembers.map((active, index) => {
                                            return (
                                                <tr key={active?.Project?.Id} className={active?.IsViolation ? "isViolation" : ""}>
                                                    {active?.ProjectDynamicFields?.length > 0 &&
                                                        active?.ProjectDynamicFields?.map((d, index) => {
                                                            return (
                                                                index == 0
                                                                    ?
                                                                    <td className="col-md-2 col-sm-1 mt-2 ">
                                                                        <div className="violationContainer">
                                                                            <div className="violationIconContainer">
                                                                                {
                                                                                    active?.IsViolation &&
                                                                                    <OverlayTrigger
                                                                                        placement={"bottom-start"}
                                                                                        delay={{ show: 150, hide: 150 }}
                                                                                        overlay={
                                                                                            <Tooltip>
                                                                                                Violation
                                                                                            </Tooltip>
                                                                                        }>
                                                                                        <img className="violationIcon" src={ViolationIcon}>
                                                                                        </img>
                                                                                    </OverlayTrigger>
                                                                                }
                                                                            </div>
                                                                            {d.Data}
                                                                        </div>

                                                                    </td>
                                                                    : index == 1
                                                                        ?
                                                                        <>
                                                                            <td className="col-md-1 col-sm-1 mt-2">
                                                                                {active.Project?.Name}
                                                                            </td>
                                                                            <td className="col-md-2 col-sm-1 mt-3 cmeMemberColumn">
                                                                                <ViewMembersPanelNew
                                                                                    UserID={active.Project?.Owner?.Id}
                                                                                    members={active.Project?.Members}
                                                                                    projects={active.Project}
                                                                                    isHidden={true}
                                                                                ></ViewMembersPanelNew>
                                                                            </td>

                                                                            <td className="col-md-1 col-sm-1 mt-2">
                                                                                {d.Data}
                                                                            </td>
                                                                        </>
                                                                        :
                                                                        index == 6
                                                                            ?
                                                                            <>
                                                                                <td className="col-md-2 col-sm-2 mt-2">
                                                                                    <CMEWorkload workload={active.MemberWorkload} />
                                                                                </td>
                                                                                <td className="col-md-1 col-sm-1 mt-2">
                                                                                    {active.AggregateMFHours}
                                                                                </td>
                                                                                <td className="col-md-1 col-sm-1 mt-2">
                                                                                    {active.AggregateSaturdayHours}
                                                                                </td>
                                                                                <td className="col-md-1 col-sm-1 mt-2">
                                                                                    {active.AggregateSundayHours}
                                                                                </td>
                                                                                <td className="col-md-1 col-sm-1 mt-2">
                                                                                    {active.AggregateTotalHours}
                                                                                </td>
                                                                                <td className="col-md-1 col-sm-1 mt-2">
                                                                                    {d.Data}
                                                                                </td>
                                                                            </>
                                                                            :
                                                                            <td className="col-md-1 col-sm-1 mt-2">
                                                                                {d.Data}
                                                                            </td>
                                                            )
                                                        })
                                                    }
                                                    <td className="col-md-1 col-sm-1 mt-2" style={{ color: getLastUpdatedDateColor(active.LastUpdated) }}>
                                                        {active.LastUpdated ?? "-"}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                            :
                            <div>
                                <DynamicFieldBulk
                                    objectType={"TaskComment"}
                                    objectId={0}
                                    taskTypeId={props.item.VacationTaskType}
                                    projectTypeId={props.item.VacationTemplateId}
                                    columnNamesNotNeeded={[]}
                                    fetchData={props.fetchData}
                                    hasProjectColumn={false}
                                    hasMemberColumn={false}
                                    hasDueDate={false}
                                />
                                <DynamicFieldBulk
                                    objectType={"TaskComment"}
                                    objectId={0}
                                    taskTypeId={props.item.DealTaskType}
                                    projectTypeId={props.item.DealTemplateId}
                                    columnNamesNotNeeded={[]}
                                    fetchData={props.fetchData}
                                    hasProjectColumn={true}
                                    hasMemberColumn={true}
                                    hasDueDate={false}
                                />
                            </div>
                        }
                    </div>
                </Modal.Body>            
        </FluentProvider>  
        </Modal>      
    )
};

CMEProjectModal.propTypes = {
    item: PropTypes.shape({
        AnalystAssociate: PropTypes.string,
        MemberProjects: PropTypes.arrayOf(PropTypes.shape({
            ProjectDynamicFields: PropTypes.arrayOf(PropTypes.shape({
                Label: PropTypes.string.isRequired,
                Value: PropTypes.string.isRequired
            })).isRequired,
            ProjectName: PropTypes.string.isRequired,
            Members: PropTypes.string.isRequired,
            Workload: PropTypes.string.isRequired,
            MFHours: PropTypes.string.isRequired,
            SaturdayHours: PropTypes.string.isRequired,
            SundayHours: PropTypes.string.isRequired,
            TotalHours: PropTypes.string.isRequired
        })).isRequired,
        IsStaffer: PropTypes.bool,
        ProjectDynamicFields: PropTypes.arrayOf(PropTypes.shape({
            Label: PropTypes.string.isRequired,
            Value: PropTypes.string.isRequired
        })).isRequired,
        VacationTemplateId: PropTypes.number,
        VacationTaskType: PropTypes.number,
        DealTemplateId: PropTypes.number,
        DealTaskType: PropTypes.number
    }).isRequired,
    fetchData: PropTypes.func,
    show: PropTypes.bool,
    onHide: PropTypes.func   
};

export default CMEProjectModal;
